class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    if (!this.notification) return;

    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    if (!this.notification) return;

    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    setTimeout(() => {
      this.notification.classList.remove('animate');
    }, 300);

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(item) {
    if (!item || (item.status && item.status !== 200)) return;

    this.updateProduct(item);
    this.updateCartButton();
    document.dispatchEvent(new CustomEvent('cart:refresh'));

    if (this.header) this.header.reveal();
    this.open();
  }

  updateProduct(item) {
    const container = document.getElementById('cart-notification-product');
    if (!container) return;

    let variantHtml = '';
    if (!item.product_has_only_default_variant && Array.isArray(item.options_with_values)) {
      variantHtml = item.options_with_values
        .map((option) => `${option.name}: ${option.value}`)
        .join('<br>');
    }

    const title = (item.product_title || item.title || '').replace(/</g, '&lt;');
    const imageUrl = item.image ? item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_160x$1$2') : '';

    container.innerHTML = `
      <div class="cart-notification-product__image">
        ${imageUrl ? `<img src="${imageUrl}" alt="${title}" width="72" height="96" loading="lazy">` : ''}
      </div>
      <div>
        <h3 class="cart-notification-product__name">${title}</h3>
        ${variantHtml ? `<p class="cart-notification-product__variant">${variantHtml}</p>` : ''}
      </div>
    `;
  }

  updateCartButton() {
    const button = document.getElementById('cart-notification-button');
    if (!button) return;

    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        button.textContent = `${button.dataset.label} (${cart.item_count})`;
      })
      .catch(() => {});
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
